export default {
  users: [
    {
      name: "kate",
      id: "1",
      phone: "919-111-1111"
    },
    {
      name: "john",
      id: "2",
      phone: "919-222-2222"
    }
  ]
};
